import { render, staticRenderFns } from "./dataSourceSon.vue?vue&type=template&id=912b9cda&scoped=true&"
import script from "./dataSourceSon.vue?vue&type=script&lang=js&"
export * from "./dataSourceSon.vue?vue&type=script&lang=js&"
import style0 from "./dataSourceSon.vue?vue&type=style&index=0&id=912b9cda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "912b9cda",
  null
  
)

export default component.exports